import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  },
});

export const getLeadAddresses = (leadId) =>
  axios.get(`${API_URL}/leads/${leadId}/addresses`, getHeaders());

export const createLeadAddress = (leadId, data) =>
  axios.post(`${API_URL}/leads/${leadId}/addresses`, data, getHeaders());

export const updateLeadAddress = (leadId, addressId, data) =>
  axios.put(`${API_URL}/leads/${leadId}/addresses/${addressId}`, data, getHeaders());

export const deleteLeadAddress = (leadId, addressId) =>
  axios.delete(`${API_URL}/leads/${leadId}/addresses/${addressId}`, getHeaders());
